import Vue from 'vue';
import App from './App';
import './assets/scss/style.scss';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js